/**
 * CardShop 运维运行时配置（localStorage；与游戏厅 ops 字段对齐便于对照）
 */
export type UpdateCheckMode = 'weekly' | 'startup' | 'manual'
export type BillChannel = 'auto' | 'com' | 'dtu'

export interface CardshopOpsConfig {
  update_check_mode: UpdateCheckMode
  /** 每周定点 HH:mm（复用字段名 daily_at 兼容旧数据） */
  update_check_daily_at: string
  /** 每周定点：0=周日 … 6=周六 */
  update_check_weekly_dow: number
  autostart_enabled: boolean
  bill_channel: BillChannel
  serial_device: string
  serial_com: string
  serial_baud: number
}

const STORAGE_KEY = 'cardshop_ops_config'

export const DEFAULT_CARDSHOP_OPS: CardshopOpsConfig = {
  update_check_mode: 'startup',
  update_check_daily_at: '03:00',
  update_check_weekly_dow: 1,
  autostart_enabled: true,
  bill_channel: 'auto',
  serial_device: 'Top',
  serial_com: '',
  serial_baud: 9600,
}

export function loadCardshopOps(): CardshopOpsConfig {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULT_CARDSHOP_OPS }
    const parsed = JSON.parse(raw) as Partial<CardshopOpsConfig> & {
      update_check_interval_hours?: number
      update_check_mode?: string
    }
    const modeRaw = String(parsed.update_check_mode ?? 'startup').toLowerCase()
    let mode: UpdateCheckMode = 'startup'
    if (modeRaw === 'manual' || modeRaw === 'none' || modeRaw === 'off') mode = 'manual'
    else if (modeRaw === 'startup' || modeRaw === 'interval') mode = 'startup'
    else if (modeRaw === 'weekly' || modeRaw === 'daily') mode = 'weekly'
    const dow = Number(parsed.update_check_weekly_dow)
    return {
      ...DEFAULT_CARDSHOP_OPS,
      ...parsed,
      update_check_mode: mode,
      update_check_weekly_dow:
        Number.isFinite(dow) && dow >= 0 && dow <= 6
          ? Math.floor(dow)
          : DEFAULT_CARDSHOP_OPS.update_check_weekly_dow,
    }
  } catch {
    return { ...DEFAULT_CARDSHOP_OPS }
  }
}

export function saveCardshopOps(patch: Partial<CardshopOpsConfig>): CardshopOpsConfig {
  const next = { ...loadCardshopOps(), ...patch }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  return next
}
